import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Input, InputIcon } from '@salesforce/design-system-react';
import * as Util from '../../../common/utilities';

import { JobBrowser } from '../';
import * as Shapes from '../../constants/shapes';

import './SelectionBrowser.scss';

class SelectionBrowser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ''
    };
  }

  componentDidUpdate(prevProps) {
    if (
      Util.propChanged(
        prevProps,
        this.props,
        'selections.data.selections.profile'
      )
    ) {
      if (
        this.props.selections?.data?.selections?.profile?.addressHash?.length
      ) {
        this.props.actions.getProfileAudit(
          this.props.selections?.data?.selections?.profile?.addressHash
        );
      }
    }
  }

  handleKeyUp({ key }) {
    if (key === 'Enter') {
      const search = this.state.searchValue?.trim();
      if (search?.length) {
        this.props.actions.getSelections(search, {
          locale: this.props.intl.locale
        });
      } else {
        this.props.actions.clearSelections();
      }
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { data, isLoading } = this.props.selections;
    const { subscriber } = data;

    return (
      <div className="selection-browser">
        <Input
          className="subscriber-search-box"
          label={formatMessage({
            id: 'components.ecs.selectionBrowser.subscriber.search.label'
          })}
          placeholder={
            subscriber?.length > 0
              ? subscriber
              : formatMessage({
                  id:
                    'components.ecs.selectionBrowser.subscriber.search.placeholder'
                })
          }
          onChange={(_evt, { value }) => this.setState({ searchValue: value })}
          onKeyUp={this.handleKeyUp.bind(this)}
          iconRight={
            <InputIcon
              assistiveText={{
                icon: 'Search'
              }}
              name="search"
              category="utility"
            />
          }
        />
        <JobBrowser
          {...data.selections}
          subscriber={data.subscriber}
          auditLog={data.auditLog || []}
          isLoading={isLoading}
          flags={this.props.flags}
          rules={this.props.rules}
          actions={this.props.actions}
          history={this.props.history}
        />
      </div>
    );
  }
}

SelectionBrowser.contextTypes = {
  router: PropTypes.object
};

SelectionBrowser.propTypes = {
  actions: PropTypes.shape({
    getSelections: PropTypes.func,
    clearSelections: PropTypes.func
  }),
  history: PropTypes.object.isRequired,
  flags: Shapes.Flags,
  rules: PropTypes.object,
  selections: Shapes.Selections,
  location: PropTypes.object
};

export default injectIntl(SelectionBrowser);
